/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

/**
 * Общие семантические CSS стили для переиспользования
 * Используются через css={commonStyles.название}
 * 
 * ⚠️ НЕ создавайте утилитарные классы (mt16, mb24, p8 и т.п.)!
 * Отступы должны быть частью семантики компонента.
 */

export const commonStyles = {
  // Утилитарные
  fullWidth: css({
    width: '100%',
  }),

  // Центрирование
  flexCenter: css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),

  flexCenterColumn: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }),

  // Текст
  smallText: css({
    fontSize: 12,
  }),

  tinyText: css({
    fontSize: 11,
  }),

  microText: css({
    fontSize: 9,
  }),

  monoText: css({
    fontFamily: 'monospace',
  }),

  secondaryText: css({
    color: '#8c8c8c',
  }),

  mutedText: css({
    color: '#bfbfbf',
  }),

  // Центрирование текста
  textCenter: css({
    textAlign: 'center',
  }),

  // Курсор
  pointer: css({
    cursor: 'pointer',
  }),

  // Таблицы/грид
  gridRow: css({
    display: 'flex',
    marginBottom: 4,
  }),

  gridHeader: css({
    display: 'flex',
    marginBottom: 8,
  }),

  // Плейсхолдеры для изображений
  imagePlaceholder: css({
    background: '#f0f0f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#bfbfbf',
  }),
};

/**
 * Размеры стандартных элементов
 */
export const sizes = {
  thumbnail: {
    small: 48,
    medium: 64,
    large: 180,
  },
  cell: {
    small: 32,
    medium: 48,
    large: 64,
  },
};

/**
 * Цвета приложения
 */
export const colors = {
  primary: '#1890ff',
  secondary: '#8c8c8c',
  muted: '#bfbfbf',
  background: '#f0f0f0',
  backgroundAlt: '#fafafa',
  border: 'rgba(0,0,0,0.06)',
  text: {
    primary: '#000000',
    secondary: '#8c8c8c',
    muted: '#bfbfbf',
  },
};

export default commonStyles;
